module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "api-table"
  }, [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), (_vm.$slots.default) ? _vm._t("default") : _vm._e(), _vm._v(" "), (_vm.slotNames.length > 1 || !_vm.$slots.default) ? _c('md-tabs', {
    staticClass: "md-transparent",
    attrs: {
      "md-dynamic-height": false
    }
  }, [(_vm.$slots.properties) ? _c('md-tab', {
    staticClass: "api-tab",
    attrs: {
      "md-label": "Properties"
    }
  }, [_vm._t("properties")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.classes) ? _c('md-tab', {
    staticClass: "api-tab",
    attrs: {
      "md-label": "Classes"
    }
  }, [_vm._t("classes")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.events) ? _c('md-tab', {
    staticClass: "api-tab",
    attrs: {
      "md-label": "Events"
    }
  }, [_vm._t("events")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.methods) ? _c('md-tab', {
    staticClass: "api-tab",
    attrs: {
      "md-label": "Methods"
    }
  }, [_vm._t("methods")], 2) : _vm._e()], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c76f50c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ApiTable.vue
// module id = 583
// module chunks = 83